import { render, staticRenderFns } from "./detailList.vue?vue&type=template&id=060d1fa0&scoped=true"
import script from "./detailList.vue?vue&type=script&lang=js"
export * from "./detailList.vue?vue&type=script&lang=js"
import style0 from "./detailList.vue?vue&type=style&index=0&id=060d1fa0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "060d1fa0",
  null
  
)

export default component.exports